// extracted by mini-css-extract-plugin
export var container = "_5o-1";
export var cornerButtonContainer = "_5o-6";
export var disabled = "_5o-2";
export var dragActive = "_5o-3";
export var fileContainer = "_5o-5";
export var hiddenInput = "_5o-4";
export var widthContainer = "_5o-0";